<template>
  <div>
    <parallax-section />
    <about-section />
    <advantages-section />
    <partners-section />
    <contact-section />
    <footer-section />
  </div>
</template>

<script>
import AboutSection from 'pages/landing/components/about-section';
import AdvantagesSection from 'pages/landing/components/advantages-section';
import PartnersSection from 'pages/landing/components/partners-section';
import ContactSection from 'pages/landing/components/contact-section';
import FooterSection from 'pages/landing/components/footer-section';
import ParallaxSection from 'pages/landing/components/parallax-section';
import setupPWARedirector from 'utils/pwa-redirector';
import cookieConsent from './components/cookie-section';

cookieConsent();

export default {
  components: {
    AboutSection,
    AdvantagesSection,
    PartnersSection,
    ContactSection,
    FooterSection,
    ParallaxSection,
  },
  mounted() {
    setupPWARedirector.call(this);
  },
};
</script>

<style>

</style>
